export const ChangeEnumJobNameToName = {
    'name': 'changeEnumJobNameToName',
    'filter': [() => {
        return (input) => {
            switch (input) {
                case 'ENV_BUILD_BY_TASKIDS':
                    return 'Build By Task';
                case 'ENV_BUILD':
                    return 'Build';
                case 'ENV_CUSTOM_BUILD':
                    return 'Custom Build';
                case 'ENV_ROLLBACK_SCR':
                case 'ENV_ROLLBACK':
                    return 'Rollback';
                case 'ENV_VALIDATE':
                    return 'Validate';
                case 'ENV_DEPLOYMENT':
                case 'ENV_UPGRADE_SCR':
                    return 'Upgrade';
                case 'ENV_SETVER':
                    return 'Set Version';
                case 'ENV_DRIFT_DETECTION':
                    return 'Drift Detection';
                case 'IMPORT_SCRIPTS':
                    return 'Auto Import';
                case 'VER_PACKAGING':
                    return 'Auto Package';
                case 'ENV_DYNAMIC_DPL':
                    return 'Build To Version';
                case 'ENV_INTEGRATION_STATE':
                    return 'Set Integration';
                case 'ENV_APPLY_LABEL':
                    return 'Apply Label';
                case 'PRECHECK':
                    return 'Pre-Check';
                case 'TRANSFER_PROJECT_PACKAGES':
                    return 'Package Transfer';
                case "RUN_PACKAGE_DEV":
                    return "Run Package Dev";
                case "UPDATE_DEV":
                    return "Update Dev";
                case "ENV_GET_SPECIFIC":
                    return "Get Specific";
                case "ENV_GET_LATEST":
                    return "Get Latest";
                case "UPDATE_SOURCE_CONTROL":
                    return "Update Source Control";
                case "ENV_RESTORE":
                    return "Restore Environment";
                case "ENV_BACKUP":                    
                    return "Backup Environment";
                case "PRE_CHECK_ENV":                    
                    return "Pre-Check Environment";
                case "PUBLISH_PROJECT":
                    return "Publish Project";
                case "VALIDATE_PROJECT_SETTINGS":
                    return "Hook Validation";
                case "RUN_PACKAGE_ADHOC":
                    return "Run Package As Adhoc";
            }
            return '';
        }
    }]
};


// WEBPACK FOOTER //
// ./src/app/common/pipes/ChangeEnumJobNameToName.js